import React from "react";
import { CheckCircle, Building2, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";

const features = [
  "Simple and cost-effective double-deck parking system",
  "Above-ground structure — no excavation required",
  "Independent car access for upper and lower platforms",
  "Quick to install and low on maintenance",
  "Perfect for low to mid-volume parking needs",
];

const applications = [
  "Small Residential Societies",
  "Individual Bungalows or Villas",
  "Commercial Offices with Tight Parking",
  "Retail Outlets and Warehouses",
  "Private Garages & Valet Zones",
];

const TwoLevelParkingDetail = () => {
    const navigate = useNavigate()
  return (
    <section className="about-wrapper">
      {/* Hero */}
      <div className="about-hero">
        <div className="hero-content">
          <h1>2 Level Parking System</h1>
          <p>
            A compact two-tier above-ground parking solution that doubles your vehicle capacity using vertical stacking — ideal for areas with limited footprint.
          </p>
        </div>
      </div>

      {/* Description */}
      <div className="about-section">
        <h2>What is 2 Level Parking?</h2>
        <p>
          2 Level Parking is a semi-automatic above-ground system that allows one vehicle to be parked above another using a hydraulic lift. It requires minimal civil work and no excavation, making it one of the most practical and cost-effective systems for quick parking expansion.
        </p>
        <p>
          Vehicles can be accessed independently depending on configuration, or with assisted operation for manual systems. It’s suitable for both residential and light commercial use.
        </p>
      </div>

      {/* Features */}
      <div className="about-section">
        <h2>Key Features & Benefits</h2>
        <ul className="lt-puzzle-list">
          {features.map((item, index) => (
            <li key={index}><CheckCircle size={18} /> {item}</li>
          ))}
        </ul>
      </div>

      {/* How it Works */}
      <div className="about-section">
        <h2>How It Works</h2>
        <p>
          The system consists of a steel frame with a liftable upper platform and a ground-level base. The upper platform is raised using a hydraulic or electro-mechanical actuator, allowing the second car to park below it. Some configurations allow direct access to either vehicle independently.
        </p>
        <p>
          Operation is simple and secure, using push-button panels or keys, with safety locks and sensors built-in to prevent misoperation.
        </p>
      </div>

      {/* Applications */}
      <div className="about-section">
        <h2>Best Suited For</h2>
        <ul className="lt-puzzle-list">
          {applications.map((item, index) => (
            <li key={index}><Building2 size={18} /> {item}</li>
          ))}
        </ul>
      </div>

      {/* Call to Action */}
      <div className="lt-puzzle-cta">
        <div className="lt-puzzle-cta-content">
          <h3>Need a 2 Level Parking system for your building?</h3>
          <p>Contact LIFTECH ENGINEERING PVT. LTD. for quick installation, expert design, and dependable service.</p>
          <button className="lt-puzzle-contact-btn" onClick={() => navigate("/get-started")}>
            <PhoneCall size={18} /> Request Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default TwoLevelParkingDetail;
